
export default {
  writeObject(key, data) {
    localStorage[key] = JSON.stringify(data);
  },
  readObject(key) {
    if (localStorage[key]) {
      return JSON.parse(localStorage[key]);
    }
    return undefined;
  },
  write(key, data) {
    localStorage[key] = data;
  },
  read(key) {
    return localStorage[key];
  },
  remove(key) {
    return localStorage.removeItem(key);
  }
};